const extend = require('lodash/extend');

module.exports = angular.module('msi.payments.paymentService', [
  require('@ordergroove/brandy/src/app/utils'),
  require('@ordergroove/brandy/src/app/core/constants'),
  require('@ordergroove/brandy/src/app/paymetric/paymetric.service')
]).name;

const inject = ['apiService', 'apiCacheService', 'ogsdk.Payment', 'paymetricService', '$cacheFactory', 'ogsdk.paymentService', 'ogsdk.addressService', '$injector'];

function PaymentService(apiService, apiCacheService, Payment, paymetricService, $cacheFactory, sdkPaymentService, addressService, $injector) {
  this.httpCache = $cacheFactory.get('$http');

  this.getPayments = sdkPaymentService.getAll.bind(sdkPaymentService);

  this.getPayment = sdkPaymentService.get.bind(sdkPaymentService);

  this.update = function(payment) {
    apiCacheService.clearPayment(payment.publicId);

    const url = `/customer/payment/${payment.publicId}/edit/`;

    /**
     The payload is different than that of create(). It has the fields of billing
     address all flattened into the payload.
     */
    const paymentPayload = payment.toApiJson();
    const addressPayload = payment.billingAddress ? payment.billingAddress.toApiJson() : {};

    const params = extend({}, addressPayload, paymentPayload);

    params.cc_number = payment.ccNumber;

    return apiService.paramAuth.get(url, { params });
  };

  this.create = function(payment) {
    // apiCeService.clearAllPayments();
    return paymetricService
      .tokenize(payment)
      .then(token => addressService.create(payment.billingAddress).then(address => ([token, address])))
      .then(([token, address]) => {
        payment.billingAddress = address;
        payment.tokenId = token;
        return sdkPaymentService.create(payment);
      });
  };

  this.useForAll = function(paymentId) {
    this.httpCache.removeAll();

    const url = `/customer/payment/${paymentId}/use_for_all/`;

    return apiService.paramAuth.get(url, { params: { paymentId } });
  };

  this.getPaymentConfig = function() {
    return $injector.has('externalPayment') ? $injector.get('externalPayment') : $injector.get('billingConfig');
  };
}

PaymentService.$inject = inject;

angular.module(module.exports).service('paymentService', PaymentService);
